<template>
  <div class="register">
    <v-stepper class="stepper" v-model="e1">
      <v-stepper-header>
        <v-stepper-step color="green" step="1">Persönliches</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="green" step="2">Profilbild</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="green" step="3">Scoutdaten</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step color="green" step="4">Links</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="5">Login</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>Persönliches</h1>
          <br />
          <h2>Jetzt benötigen wir allgemeine Infos über dich.</h2>
          <br />
          <label>Vor- und Nachname</label>
          <v-text-field
            placeholder
            color="green"
            v-model="common_infos.name"
            solo
          ></v-text-field>
          <label>Geburtsdatum</label>
          <v-menu
            ref="menu"
            locale="de"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            color="green"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                solo
                color="green"
                v-model="settings.age"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="green"
              ref="picker"
              v-model="settings.age"
              :max="new Date().toISOString().substr(0, 10)"
              min="1950-01-01"
            ></v-date-picker>
          </v-menu>
          <label>Geschlecht</label>
          <v-select color="green" :items="sex" v-model="settings.sex" solo></v-select>
          <label>Nationalität</label>
          <v-autocomplete
            :no-data-text="'Keine Einträge vorhanden'"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            name="nationalities"
            v-model="settings.nationality"
            solo
            attach
          ></v-autocomplete>
          <label>Sprachen</label>
          <v-select
            v-model="settings.languages"
            color="green"
            :items="$store.state.languages"
            solo
            chips
            multiple
          ></v-select>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>
        <v-stepper-content class="content" step="2">
          <h1>Profilbild</h1>
          <br />
          <h2>
            Ein vernünftiges Bild von dir für deine Außendarstellung. Das kannst du aber
            auch später erledigen.
          </h2>
          <br />
          <input
            class="fileInput"
            type="file"
            accept="image/*"
            @change="onFileSelected"
          />
          <br />
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>
        <v-stepper-content class="content" step="3">
          <h1>Scoutdaten</h1>
          <br />
          <h2>Hier sind Informationen über deine Tätigkeit als Scout gefragt.</h2>
          <br />
          <label>Scoutgebiet</label>
          <v-select
            color="green"
            :items="$store.state.scoutarea"
            v-model="settings.scoutarea"
            solo
            multiple
          ></v-select>
          <label>Scoutbereich</label>
          <v-select
            color="green"
            :items="$store.state.scout_segment"
            v-model="settings.bundesland"
            solo
            multiple
          ></v-select>
          <label>Tätig für</label>
          <v-text-field
            placeholder="Vereins-, Unternehmens- oder Agenturname "
            color="green"
            v-model="settings.working_for"
            solo
          ></v-text-field>
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>
        <v-stepper-content class="content" step="4">
          <h1>Links</h1>
          <br />
          <h2>
            Solltest du bereits ein Transfermarkt-Profil oder eine Website haben, dann
            kannst du sie in deinem C4T-Profil anzeigen lassen.
          </h2>
          <br />
          <label for>Link Transfermarkt-Profil (optional)</label>
          <v-text-field
            hint="Kopiere den Link von deinem Transfermarkt-Profil."
            color="green"
            v-model="common_infos.transfermarkt"
            solo
          ></v-text-field>
          <label>Link Website (optional)</label>
          <v-text-field
            color="green"
            hint="Kopiere die URL der Website."
            v-model="common_infos.website"
            solo
          ></v-text-field>

          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" :loading="loading" @click="saveSettings"
            >Fertig</v-btn
          >
        </v-stepper-content>
        <v-stepper-content class="content" step="5">
          <h1>Login</h1>
          <br />
          <h2>
            Wir haben jetzt alle relevanten Informationen erhalten und dein Scoutprofil
            erstellt.
          </h2>
          <br />
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="loginScout(email, password, 'scouts')"
            >Login</v-btn
          >
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import firebase from 'firebase';
import axios from 'axios';
import { db } from '@/db';
import Button from '@/components/Button';
import Input from '@/components/Input';
import { cloudFunctions } from '../../config';

export default {
  components: {
    Button,
    Input,
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },
  data: () => ({
    menu: false,
    e1: 1,
    loading: false,
    date: new Date().toISOString().substr(0, 10),
    common_infos: {
      name: '',
      date: '2018-03-02',
      profile_pic: '',
      history: [],
    },
    settings: {
      working_for: '',
      player_age_range: [14, 20],
      trainer_age_range: [14, 20],
      userType: 'scout',
      galleryImages: ['', '', '', ''],
      team_country: 'DE',
      player_country: 'Deutschland',
      trainer_country: 'Deutschland',
      newslinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
      videolinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
    },
    search: [
      {
        ageRange: [17, 25],
      },
    ],
    email: '',
    password: '',
    picture: '',
    uploading: false,
    select: { state: 'Florida', abbr: 'FL' },
    landkreis: ['Ohrekreis', 'Salzlandkreis', ''],
    need: ['Spieler', 'Trainer', 'Kein Bedarf'],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    showPW: false,
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),
  computed: {
    getNationality() {
      if (this.settings.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.settings.nationality,
        );
        return found.item_text;
      }
    },
  },
  methods: {
    next() {
      this.e1++;
      window.scrollTo(0, 0);
    },
    back() {
      this.e1--;
      window.scrollTo(0, 0);
    },
    loginScout(email, password, collection) {
      this.$store.state.user_uid = firebase.auth().currentUser.id;
      this.$store.state.user_data.intro = false;
      this.$router.push({ name: 'scout_home' });
    },
    saveSettings() {
      if (this.common_infos.website) {
        this.common_infos.website = this.common_infos.website.replace('https://', '');
      }
      if (this.common_infos.transfermarkt) {
        this.common_infos.transfermarkt = this.common_infos.transfermarkt.replace(
          'https://',
          '',
        );
      }
      this.loading = true;
      if (this.common_infos.profile_pic === '') {
        this.common_infos.profile_pic =
          'https://firebasestorage.googleapis.com/v0/b/chance4talents-d54b5.appspot.com/o/player-avatar.jpg?alt=media&token=a1eb2783-1755-441a-91fb-0eaccca9d85d';
        this.common_infos.big_thumbnail =
          'https://firebasestorage.googleapis.com/v0/b/chance4talents-d54b5.appspot.com/o/player-avatar.jpg?alt=media&token=a1eb2783-1755-441a-91fb-0eaccca9d85d';
      }
      this.$store.state.user_data = {
        ...this.$store.state.user_data,
        ...this.settings,
        search: this.search,
        ...this.common_infos,
        intro: false,
      };
      db.collection('scouts')
        .doc(firebase.auth().currentUser.uid)
        .update({
          ...this.settings,
          search: this.search,
          ...this.common_infos,
          intro: false,
        })
        .then(() => {
          this.loading = false;
          this.e1++;
          window.scrollTo(0, 0);
        })
        .then((e) => {
          this.loading = false;
        });
    },
    onFileSelected(event) {
      this.picture = event.target.files[0];
      this.resizeImage(this.picture);
    },
    resizeImage() {
      this.$store.state.loading = true;

      const file = this.picture;

      // Create an image
      const img = document.createElement('img');
      // Create a file reader
      const reader = new FileReader();
      // Set the image once loaded into file reader
      reader.onload = function (e) {
        img.src = e.target.result;

        const canvas = document.createElement('canvas');
        // var canvas = $("<canvas>", {"id":"testing"})[0];
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        const MAX_WIDTH = 400;
        const MAX_HEIGHT = 300;
        let { width } = img;
        let { height } = img;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        const dataurl = canvas.toDataURL('image/png');
        this.picture = dataurl;
      };
      // Load files into file reader
      reader.readAsDataURL(file);

      this.uploadIMG();
    },
    uploadIMG() {
      const storageRef = firebase
        .storage()
        .ref(`images/${this.$store.state.user_data.id}/` + 'profilepic.png');
      storageRef
        .put(this.picture)
        .then((e) => {
          this.sucess_upload = e;
          return e.ref.getDownloadURL();
        })
        .then((downloadURL) => {
          this.common_infos.thumbnail = downloadURL;
          this.common_infos.big_thumbnail = downloadURL;
          this.common_infos.profile_pic = downloadURL;
          this.saveSettings();
        })
        .then(() => {
          if (this.success_upload.state === 'success') {
            if (window.location) {
              window.location.reload();
            } else location.reload();
          } else {
            this.$store.state.snackText =
              'Ups etwas ist schief gelaufen versuche es nochmal.';
            this.$store.state.snackbar = true;
          }
        })
        .catch((e) => {
          this.$store.state.loading = false;
        });
    },
    registerTeam(email, password) {
      this.loading = true;
      const data = {
        email,
        password,
      };
      const json = JSON.stringify(data);
      axios({
        method: 'post',
        url: `${cloudFunctions}/createScout`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then((resp) => {
          this.$store.state.user_uid = resp.data.uid;
          this.loading = false;
        })
        .then(() => {
          this.e1++;
          window.scrollTo(0, 0);
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.fileInput {
  margin-bottom: 15px;
}
.register {
  padding: 0;
  margin: 0;
  padding-bottom: 255px;
  text-align: left;
}
.v-btn {
  margin-left: 0;
}
h2 {
  color: grey;
  font-weight: 400;
  font-size: 16px;
}
.stepper {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 20px;
}

label {
  font-weight: bold;
  color: $primary-dark;
}

.items {
  width: 100%;
  background: rgb(248, 248, 248);
  min-height: 89vh;
}

.datepicker {
  margin-bottom: 20px;
}
</style>
